export {
  NEWS_LOCALE_REDIRECT_SCRIPT,
  NEWS_NAV_LABELS,
  newsNavLabel,
} from "../../../api/lib/news-locale-redirect.mjs";
